import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const label: Interpolation<Theme> = (theme) => css`
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const item: (error?: boolean) => Interpolation<Theme> = (error) => (theme) =>
  css`
    display: flex;
    gap: 8px;
    padding: 6px;
    background: ${theme.backgrounds.backgroundFour};
    border: 1px solid ${error ? theme.colors.red : theme.backgrounds.backgroundOne};
    box-shadow: ${theme.boxShadows.small};
    border-radius: 14px;
  `

export const empty: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyThree};
`

export const content: Interpolation<Theme> = (theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyTwo};
  overflow-wrap: anywhere;
`

export const iconButton: Interpolation<Theme> = css`
  &.MuiButtonBase-root {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`
